import clsx from 'clsx';
import {DefaultFileIcon} from './icons/default-file-icon';
import {AudioFileIcon} from './icons/audio-file-icon';
import {VideoFileIcon} from './icons/video-file-icon';
import {TextFileIcon} from './icons/text-file-icon';
import {PdfFileIcon} from './icons/pdf-file-icon';
import {ArchiveFileIcon} from './icons/archive-file-icon';
import {FolderFileIcon} from './icons/folder-file-icon';
import {ImageFileIcon} from './icons/image-file-icon';
import {PowerPointFileIcon} from './icons/power-point-file-icon';
import {WordFileIcon} from './icons/word-file-icon';
import {SpreadsheetFileIcon} from './icons/spreadsheet-file-icon';
import {SharedFolderFileIcon} from './icons/shared-folder-file-icon';

interface Props {
  type?: string;
  mime?: string | null;
  className?: string;
}
export function FileTypeIcon({type, mime, className}: Props) {
  if (!type && mime) {
    type = mime.split('/')[0];
  }
  console.log('type',type);
  // @ts-ignore
  const DefaultFileIcon = './images/icons/DefaultFileIcon.png';
  const AudioFileIcon = './images/icons/AudioFileIcons.png';
  const VideoFileIcon = './images/icons/VideoFileIcon.png';
  const TextFileIcon = './images/icons/TextFileIcon.png';
  const PdfFileIcon = './images/icons/PdfFileIcon.png';
  const ArchiveFileIcon = './images/icons/ArchiveFileIcon.png';
  const FolderFileIcon = './images/icons/FolderIcon.png';
  const ImageFileIcon = './images/icons/ImageFileIcon.png';
  const PowerPointFileIcon = './images/icons/PowerPointFileIcon.png';
  const WordFileIcon = './images/icons/WordFileIcon.png';
  const SpreadsheetFileIcon = './images/icons/SpreadsheetFileIcon.png';
  const SharedFolderFileIcon = './images/icons/SharedFolderFileIcon.png';
  // @ts-ignore
  //const Icon = FileTypeIcons[type] || FileTypeIcons.default;
  let img = '';
  switch (type) {
    case 'pdf':
      img = PdfFileIcon;
      break;
    case 'image':
      img = ImageFileIcon;
      break;
    case 'text':
      img = TextFileIcon;
      break;
    case 'shared':
      img = SharedFolderFileIcon;
      break;
    case 'powerpoint':
      img = PowerPointFileIcon;
      break;
      case 'powerPoint':
      img = PowerPointFileIcon;
      break;  
    case 'word':
      img = WordFileIcon;
      break;
    case 'spreadsheet':
      img = SpreadsheetFileIcon;
      break;
    case 'folder':
      img = FolderFileIcon;
      break;
    case 'Archive':
      img = ArchiveFileIcon;
      break;
    case 'audio':
      img = AudioFileIcon;
      break;
    case 'video':
      img = VideoFileIcon;
      break;
    case 'default':
      img = DefaultFileIcon;
      break;

  }
  console.log('type',type,img);
 // const Icon = FileTypeIcons[type] || FileTypeIcons.default;
  return (
    // <Icon
    //   className={clsx(className, `${type}-file-color`)}
    //   viewBox="0 0 64 64"
    // />
    <img src={img} width={20} />
  );
}

const FileTypeIcons = {
  default: DefaultFileIcon,
  audio: AudioFileIcon,
  video: VideoFileIcon,
  text: TextFileIcon,
  pdf: PdfFileIcon,
  archive: ArchiveFileIcon,
  folder: FolderFileIcon,
  sharedFolder: SharedFolderFileIcon,
  image: ImageFileIcon,
  powerPoint: PowerPointFileIcon,
  word: WordFileIcon,
  spreadsheet: SpreadsheetFileIcon,
};
